module.exports = __webpack_public_path__ + "img/icb-leo-Adv-e@3x.a1d471ad.png";